var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('member-add-wizard',{staticClass:"mt-2 pt-75",attrs:{"allGroups":_vm.getAllGroups,"allAppointments":_vm.getAllAppointments}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }